import { render, staticRenderFns } from "./transporter-link.component.vue?vue&type=template&id=16a7fa8f&"
import script from "./transporter-link.component.vue?vue&type=script&lang=ts&"
export * from "./transporter-link.component.vue?vue&type=script&lang=ts&"
import style0 from "./transporter-link.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "transporter-link.component.vue"
export default component.exports